import { render } from "./mxjersey.vue?vue&type=template&id=37f3418b"
import script from "./mxjersey.vue?vue&type=script&lang=js"
export * from "./mxjersey.vue?vue&type=script&lang=js"

import "./mxjersey.vue?vue&type=style&index=0&id=37f3418b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__